/* @flow */

import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from 'reducers/index';

export default function configureStore(preloadedState: {}) {
  return createStore(
    reducers,
    preloadedState,
    applyMiddleware(
      thunkMiddleware,
    ),
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js